module.exports = __webpack_public_path__ + "img/giraffe.c03306c.png";